import React from 'react';
import styles from './styles.css';

export const ProBadge = <span className={styles.root}>PRO</span>;
export const NewBadge = <span className={styles.root}>BETA</span>;
